import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, Button, Form, Spinner } from 'react-bootstrap'
import { createRssFeed, listRssFeeds } from '../actions/rssActions'
import Message from './Message'

function RssFeedModal({ show, onHide }) {
    const dispatch = useDispatch()
    const [name, setName] = useState('')
    const [url, setUrl] = useState('')
    const [validationErrors, setValidationErrors] = useState({})

    const { loading, error, success } = useSelector(state => state.rssFeedCreate)

    const validateForm = () => {
        const errors = {}
        if (!name.trim()) errors.name = 'Feed name is required'
        if (!url.trim()) {
            errors.url = 'Feed URL is required'
        } else if (!/^https?:\/\/.+/.test(url)) {
            errors.url = 'Please enter a valid URL (http:// or https://)'
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const errors = validateForm()
        
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors)
            return
        }

        setValidationErrors({})
        
        // Dispatch create action
        await dispatch(createRssFeed(name, url))
        
        // After successful creation, refresh feeds list
        if (success) {
            setTimeout(() => {
                setName('')
                setUrl('')
                dispatch(listRssFeeds())
                onHide()
            }, 500)
        }
    }

    const handleClose = () => {
        setName('')
        setUrl('')
        setValidationErrors({})
        onHide()
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontWeight: '700', color: 'var(--bnb-navy)' }}>
                    <i className="fa-solid fa-rss me-2" style={{ color: 'var(--bnb-gold)' }}></i>
                    Add RSS Feed
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Message variant="danger">{error}</Message>}
                
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: 'var(--bnb-navy)' }}>
                            Feed Name
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g., PGA Tour News"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            isInvalid={!!validationErrors.name}
                            disabled={loading}
                        />
                        <Form.Control.Feedback type="invalid">
                            {validationErrors.name}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: '600', color: 'var(--bnb-navy)' }}>
                            Feed URL
                        </Form.Label>
                        <Form.Control
                            type="url"
                            placeholder="https://example.com/feed.xml"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            isInvalid={!!validationErrors.url}
                            disabled={loading}
                        />
                        <Form.Control.Feedback type="invalid">
                            {validationErrors.url}
                        </Form.Control.Feedback>
                        <Form.Text className="d-block mt-2" style={{ fontSize: '0.8rem', color: 'var(--bnb-gray)' }}>
                            Enter the RSS feed URL (must start with http:// or https://)
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    onClick={handleClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    style={{ background: 'var(--bnb-navy)', border: 'none' }}
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Creating...
                        </>
                    ) : (
                        <>
                            <i className="fa-solid fa-plus me-1"></i> Add Feed
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RssFeedModal
